import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitchSimple2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 45,
	height: 21,
	viewBox: "0 0 45 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.393554 2.00879H15.9475L28.0449 18.9272H44.4629",
		stroke: "currentColor",
		strokeWidth: 4
	})
});
export default SvgSwitchSimple2;
